/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction } from 'state/ui/actions';

const openModal = createOpenModalAction('EditDashboardPopover');

export default (dashboardId) => (dispatch) => {
	dispatch({ type: actions.DASHBOARD_FORM_START, payload: { dashboardId } });
	dispatch(openModal());
};
